import { useMemo } from "react";
import { useLiveRanking } from "../../hooks/useLiveRanking";
import { formatNumber } from "../../utils/formatNumber";
import "./OverviewCards.css";



const TOP_N = 3;


function withOwnChannel(rows) {
  const top = rows.slice(0, TOP_N);
  const own = rows.find((r) => r.isOwn);

  if (!own || top.some((r) => r.isOwn)) return { list: top, gap: false };
  return { list: [...top, own], gap: true };
}

export default function OverviewRankingCard({ channelId, refreshKey }) {
  const { rows, loading } = useLiveRanking(channelId, refreshKey);

  // This card is the YouTube board, so a channel reporting TV viewers has no
  // place on it. Ranks are renumbered over what is left — carrying the full
  // ranking's numbers here would print a 1, 2, 4 with no explanation.
  const ytRows = useMemo(() => {
    let rank = 0;
    return rows
      .filter((r) => r.source !== "TV")
      .map((r) => ({ ...r, rank: r.offAir ? null : ++rank }));
  }, [rows]);

  const { list, gap } = useMemo(() => withOwnChannel(ytRows), [ytRows]);

  return (
    <div className="overview-card card-purple ov-list-card">
      <div className="card-icon">
        <i className="fa-brands fa-youtube" />
      </div>

      <ol className="ov-list">
        {list.map((row, i) => (
          <li
            key={row.id}
            className={`ov-list-item ${row.isOwn ? "is-own" : ""} ${
              row.offAir ? "is-offair" : ""
            } ${gap && i === list.length - 1 ? "after-gap" : ""}`}
          >
            <span className="ov-list-rank">{row.rank ?? "–"}</span>
            {row.logo ? (
              <img className="ov-list-logo" src={row.logo} alt="" />
            ) : (
              <span className="ov-list-logo ov-list-logo--blank" />
            )}
            <span className="ov-list-name" title={row.name}>
              {row.name}
            </span>
            <span className="ov-list-value">
              {row.offAir ? "off air" : formatNumber(row.value)}
            </span>
          </li>
        ))}

        {loading && ytRows.length === 0 && <li className="ov-list-empty">…</li>}
        {!loading && ytRows.length === 0 && (
          <li className="ov-list-empty">No streams to rank.</li>
        )}
      </ol>

      {/* Bottom-aligned label, the same shape the KPI cards use. */}
      <div className="card-title">Inteltube live ranking</div>
    </div>
  );
}
